import _ from 'lodash';
import { FileUploadType } from '../../UI/Pages/DLPages/DLPriceInputPage';
import { arrayToString } from '../ApiHelper/ErrorMessages';
import {
  excelDlEpCodeHeader,
  excelDlPriceHeader
} from './ExcelExportDlEpHelper';

const ExcelJS = require('exceljs');

export function importDlEpExcel(excel: FileUploadType) {
  return new Promise((resolve, reject) => {
    if (!excel || !excel.file) {
      reject(
        'Bitte importieren Sie eine valide Datei. Die Datei konnte nicht gelesen werden.'
      );
    } else {
      const workbook = new ExcelJS.Workbook();
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        const buffer =
          e && e.target && e.target.result ? e.target.result : null;
        workbook.xlsx
          .load(buffer)
          .then(async (wb: any) => {
            initData(wb)
              .then((data: any) => {
                resolve(data);
              })
              .catch((error: any) => reject(error));
          })
          .catch((error: any) => {
            reject(
              'Bitte importieren Sie eine valide Datei. Die Datei konnte nicht gelesen werden.'
            );
          });
      };

      fileReader.readAsArrayBuffer(new Blob([excel.file]));
    }
  });
}

function initData(wb: any) {
  return new Promise((resolve, reject) => {
    const sheetDlEp = wb.worksheets[0];

    if (sheetDlEp) {
      //parse data
      createKeyValues(sheetDlEp)
        .then((values) => {
          resolve(values);
        })
        .catch((error) => reject(error));
    } else {
      reject(
        'Bitte importieren Sie eine valide Datei mit mindestens einem Blatt. Das erste Blatt der Excel-Datei wird eingelesen.'
      );
    }
  });
}

function createKeyValues(sheet: any) {
  return new Promise((resolve, reject) => {
    let headlines: string[] = [];
    let pricesheet: any = [];
    let errorPriceNANRows: number[] = [];
    let errorPriceDecimalsRows: number[] = [];

    //read contained data
    sheet.eachRow((row: any, rowNumber: number) => {
      if (rowNumber === 1 || rowNumber === 2) {
        //skip
      } else if (rowNumber === 3) {
        headlines.push(...row.values);
      } else {
        let payload: any = {};
        row.eachCell(
          { includeEmpty: true },
          function (cell: any, colNumber: number) {
            let cellVal = cell.value;
            //use results if there is any kind of formula

            cellVal =
              cellVal && (cellVal.result || cellVal.result === 0)
                ? cellVal.result
                : cell._value &&
                  (cell._value.result || cell._value.result === 0)
                ? cell._value.result
                : cellVal;

            //Save price epcode and rownumber
            if (
              calcAttributeName(headlines, colNumber) === excelDlPriceHeader
            ) {
              //check if value is a number

              if (
                cellVal !== null &&
                cellVal !== undefined &&
                typeof cellVal !== 'number'
              ) {
                errorPriceNANRows.push(rowNumber);
              } else {
                //check decimals are smaller than 3
                if (countDecimals(cellVal) > 3) {
                  errorPriceDecimalsRows.push(rowNumber);
                } else {
                  payload['price'] = cellVal;
                  payload['row'] = rowNumber;
                }
              }
            } else if (
              calcAttributeName(headlines, colNumber) === excelDlEpCodeHeader
            ) {
              payload['epCode'] = cellVal;
              payload['row'] = rowNumber;
            }
          }
        );

        if (payload && Object.keys(payload).length > 0) {
          pricesheet.push(payload);
        }
      }
    });
    //errorhandling
    if (errorPriceNANRows && errorPriceNANRows.length > 0) {
      if (errorPriceNANRows.length === 1) {
        reject(
          'Der angegebene Rahmenpreis in der Zeile: ' +
            arrayToString(errorPriceNANRows) +
            ' ist keine Zahl. Bitte geben Sie eine gültige Zahl ein und importieren Sie die Datei erneut.'
        );
      } else {
        reject(
          'Die angegebenen Rahmenpreise in den Zeilen: ' +
            arrayToString(errorPriceNANRows) +
            ' sind keine Zahl. Bitte geben Sie eine gültige Zahl ein und importieren Sie die Datei erneut.'
        );
      }
    }
    if (errorPriceDecimalsRows && errorPriceDecimalsRows.length > 0) {
      if (errorPriceDecimalsRows.length === 1) {
        reject(
          'Der angegebene Rahmenpreis in der Zeile: ' +
            arrayToString(errorPriceDecimalsRows) +
            ' hat mehr als 3 Nachkommastellen. Bitte geben Sie eine gültige Zahl mit 3 oder weniger Nachkommastellen ein (z.B. 1,426) und importieren Sie die Datei erneut.'
        );
      } else {
        reject(
          'Die angegebenen Rahmenpreise in den Zeilen: ' +
            arrayToString(errorPriceDecimalsRows) +
            ' haben mehr als 3 Nachkommastellen. Bitte geben Sie eine gültige Zahl mit 3 oder weniger Nachkommastellen ein (z.B. 1,426) und importieren Sie die Datei erneut.'
        );
      }
    }
    if (pricesheet) {
      //check for uniqueness of epCodes

      let epCodes: any = _.mapValues(pricesheet, 'epCode');
      epCodes = _.valuesIn(epCodes);
      epCodes = _.remove(epCodes, function (n: string) {
        return n !== undefined && n !== null;
      });

      const uniqueCodes = _.uniq(epCodes);

      if (epCodes.length !== uniqueCodes.length) {
        const doubleEps = epCodes.reduce(function (
          acc: string[],
          el: string,
          i: number,
          arr: string[]
        ) {
          if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
          return acc;
        },
        []);

        reject(
          'Die Positionen mit den EP-Codes: ' +
            doubleEps.toString() +
            ' sind nicht eineindeutig. Jeder Ep-Code darf nur ein mal vorkommen. Bitte korrigieren Sie die Excel-Tabelle und versuchen Sie es erneut.'
        );
      }

      resolve(pricesheet);
    }

    reject(
      'Die Datei konnte nicht gelesen werden. Bitte laden Sie eine valide Excel-Tabelle hoch.'
    );
  });
}

function calcAttributeName(headlines: string[], colNumber: number) {
  return headlines[colNumber];
}

function countDecimals(value: number) {
  if (value && value % 1 !== 0) {
    if (value.toString().split('.')[1]) {
      return value.toString().split('.')[1].length;
    }
  }

  return 0;
}
